export const CURRENTLY_BEING_ASSISTED_QUEUE_POSITION = -1;

export const NEXT_IN_LINE_QUEUE_POSITION = 1;
